// Queue class for serializing AJAX calls.
//
// Inspired by Raynos http://stackoverflow.com/a/4797596/1194060
//
// Queue has a public append method that expects some kind of task.
// A task is a generic function passed as callback.
// Constructor expects a handler which is a method that takes a ajax task
// and a callback. Queue expects the handler to deal with the ajax and run
// the callback when it's finished

function Queue(handler) {
	const queue = []

	function run() {
		const callback = function () {
			queue.shift()
			// when the handler says it's finished (i.e. runs the callback)
			// We check for more tasks in the queue and if there are any we run again
			if (queue.length > 0) {
				run()
			}
		}
		// give the first item in the queue & the callback to the handler
		handler(queue[0], callback)
	}

	// push the task to the queue. If the queue was empty before the task was pushed
	// we run the task.
	this.append = function (task) {
		queue.push(task)
		if (queue.length === 1) {
			run()
		}
	}
}

export default Queue